"use client";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/free-solid-svg-icons";

type ButtonProps = {
  title: string;
  icon: IconDefinition;
  action: () => void;
};

export default function Button({ title, icon, action }: ButtonProps) {
  return (
    <button
      onClick={action}
      className="flex flex-row text-nowrap justify-center items-center gap-2 rounded-sm px-5 py-2 w-min self-start hover:bg-primary-yellow bg-white text-background-grey cursor-pointer transition-colors"
    >
      <span>{title}</span>
      <FontAwesomeIcon icon={icon} />
    </button>
  );
}
